<template lang="pug">
#questionnaires-register(v-cloak)
  .box(@click="resetFocus")
    .box-header.d-flex.flex-row
      .titles
        .title
          span アンケートの新規作成
        .note
          span アンケート項目は「選択肢」「テキスト」を選択できます（最大50項目）。
          br
          span 選択肢の場合、選択肢を50つまで作成できます。

    .box-body.register-body
      .sub-title.mb-2 ①アンケート項目の作成
      .questionnaire-contents
        FormInput(v-model="title" key-name="タイトル" type="text" name="title" placeholder="タイトル"
          :maxlength="100" :validation-rules="{ required: true, max: 100 }" required)
        FormTextarea(v-model="text" key-name="説明文" name="text" 
          placeholder="アンケート回答前に確認いただきたい内容（目的など）を記載してください。\n回答期限や回答所要時間も記載すると良いと思います。"
          :maxlength="1000" :validation-rules="{ max: 1000 }"
          :styles="{ maxWidth: '600px', width: '600px', minHeight: '160px' }")
        FormMultiFile(:registerImageFilesLimit="_registerImageFilesLimit" :enablePreviewStatus="_enablePreviewStatus"
          @inputFiles="inputFiles" @onTempFilePreview="onTempFilePreview")
        .register-row
          DraggableFiles(v-model="files" @delete="onFileDelete" :item-width="'468px'")
        FormCheck(v-model="hidden" key-name="匿名回答" name="hidden" label="回答者を匿名にする")
          template(#description)
            span.error-message ※匿名にすると、回答結果に回答者の情報は表示されません。

        .questionnaires
          .mb-2
            span.sub-title.mr-1 質問項目
            span.validation-label 必須
          .questionnaire.mb-2(v-for="(question, index) in questions" @click.stop="focusInQuestion(index)")
            QuestionInputItem(v-model="questions[index]" :index="index" :disableMoveDown="index == (questions.length -1)" :disableMoveUp="index == 0"
              @onDelete="onQuestionDelete" @onOptionDelete="onQuestionOptionDelete" @onAddSelectOption="onQuestionAddSelectOption"
              @onMoveDown="onQuestionMoveDown" @onMoveUp="onQuestionMoveUp")
        .add-question-buttons
          .d-flex.flex-row.align-items-center
            select.input-select.mr-2(v-model="questionType" style="width: 240px;")
              option(v-for="option in questionTypeOptions" :value="option.value") {{ option.label }}
            button.btn.add-question-btn.mr-2(@click="addQuestion(questionType)"
              :disabled="_disableQuestionnaireBtn" :class="{ 'disable': _disableQuestionnaireBtn }") 質問項目追加
            button.btn.preview-btn(@click="previewQuestion" :disabled="_disablePreviewBtn" :class="{ 'disable': _disablePreviewBtn }") プレビュー
        .register-row.mt-2(v-show="questionErrorMessage")
          .register-group
            .register-value
              .error-message {{ questionErrorMessage }}
      .mb-4

      .sub-title.mb-2 ②回答期限の設定
      .questionnaire-contents
        FormCheck(v-model="enableAnswerLimit" key-name="" name="enable-answer-limit" label="回答期限を設定する")
        FormDatetimePicker(v-if="enableAnswerLimit == true" v-model="replyLimit" :date.sync="replyLimitDate" :time.sync="replyLimitTime"
          placeholder="回答期限" key-name="日付・時間" name="answer-limit")
      .mb-4

      .sub-title.mb-2 ③メッセージ送信内容の作成
      .questionnaire-contents
        SendMessageTargetCheck(v-model="targetType")
        SendMessageTargetsInput(ref="sendMessageTargetsInput" v-model="targetType" :groupType="groupType"
          @onFamiliesSelect="onFamiliesSelect" @onOtherUserGroupsSelect="onOtherUserGroupsSelect" @onSendMessageGroupSelect="onSendMessageGroupSelect"
          @loadedFamiliesTargets="loadedFamiliesTargets" @loadedOtherUserTargets="loadedOtherUserTargets" @loadedGroupTargets="loadedGroupTargets")
        .register-row.mt-2(v-show="targetErrorMessage")
          .register-group
            .register-value
              .error-message {{ targetErrorMessage }}
        FormInput(v-model="messageTitle" key-name="タイトル" name="message-title" type="text" placeholder="送信メッセージタイトル" :maxlength="100"
          :validation-rules="{ required: true, max: 100 }" required)
        FormTextarea(v-model="messageText" key-name="本文" name="message-text" placeholder="送信メッセージ本文を入力してください。" :maxlength="1000"
          :validation-rules="{ required: true, max: 1000 }" :styles="{ maxWidth: '600px', width: '600px', minHeight: '160px' }" required)
      .mb-4

      .sub-title ④共有ユーザーの設定
      .share-standard-users.mb-2
        div 共有されたユーザーは修正・回答結果の閲覧ができます。
        div 送信後も共有ユーザーの設定変更ができます。
        div.warning-message ※ 管理者ユーザーには必ず共有されます。
        div.warning-message ※ 作成者を共有ユーザーから外すことはできません。
        div.warning-message ※ 一般ユーザーはアンケートの使用機能権限も合わせて必要です。
      ShareStandardUserCheckboxs(v-model="shareStandardUsers")

    .box-footer.with-border.register-footer
      ValidationAlert(v-model="showValidationAlert")
      .buttons
        button.btn.register-btn(@click="showRegisterConfirmModal" type="button") 一時保存
        button.btn.send-btn(@click="showSendConfirmModal" type="button") 送信
        button.btn.cancel-btn(@click="gotoQuestionnaireList" type="button") キャンセル

  SendMessageSelectModal(ref="sendMessageSelectModal" @add="addFamiliesTarget")
  SendMessageOtherUserGroupSelectModal(ref="otherUserGroupSelectModal" @add="addOtherUserGroupTarget")
  SendMessageGroupSelectModal(ref="sendMessageGroupSelectModal" :planType="planType" :groupType.sync="groupType" @add="addSendGroupTarget")

  QuestionnaireFilePreviewModal(ref="filePreviewModal")
  PreviewQuestionnairesMoldal(v-model="showPreviewModal" :title="title" :text="text" :questions="questions")

  OkCancelModal(v-model="showRegisterModal" title="アンケートを一時保存します。よろしいですか？" @ok="registerQuestionnaire")
  OkModal(v-model="showRegisterSuccessModal" title="登録に成功しました。" @ok="gotoQuestionnaireList")

  OkCancelModal(v-model="showSendModal" title="アンケートを送信します。よろしいですか？" @ok="sendQuestionnaire")
  OkModal(v-model="showSendSuccessModal" title="アンケート送信を受け付けました。" @ok="gotoQuestionnaireList")

  //- file upload error modal
  FileUploadErrorModal(v-model="showUploadErrorModal")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
  ProgressLoading(v-model="currentUploadCount" :max="uploadCount" :isBusy="progressLoading" :message="progressMessage")
</template>

<script lang="ts">
import { Component, Inject, Ref, Vue } from "vue-property-decorator";
import { userStore, screenInputTemporaryStore } from "@/store/store";
import { PcUrl } from "@/commons/constants/PcUrl";

import { SendMessageTargetGroup } from "@/commons/models/SendMessageTarget";
import { OtherUserGroupTypeGroup } from "@/commons/services/OtherUserGroupTypeMembers";

import QuestionnairesService, { TemplateType, QuestionnairesPostModel, TargetType, QuestionTemplateItem, QuestionnairesGetModel, FileUrl } from "@/commons/services/Questionnaires";
import { PlanType } from "@/commons/services/Plans";
import StandardAccountsService, { StandardAccountsGetModel } from "@/commons/services/StandardAccounts";
import S3LocationsService from "@/commons/services/S3Locations";
import { S3LocationRequest, S3LocationResponse, S3LocationType, S3LocationMessage } from "@/commons/models/S3Location";
import S3UploadsService from "@/commons/services/S3Uploads";
import ExistS3FilesService, { ExistS3FilesPostModel } from "@/commons/services/ExistS3Files";

import QuestionnaireFileCommon from "@/commons/services/QuestionnaireFileCommon";

import FileUploadErrorModal from "@/pc/basics/FileUploadErrorModal.vue";
import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ProgressLoading from "@/pc/basics/ProgressLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import FormMultiFile from "@/pc/containers/questionnaires/FormMultiFile.vue";
import DraggableFiles, { ExtDraggableFile } from "@/pc/components/ExtDraggableFiles.vue";
import FormCheck from "@/pc/components/forms/FormCheck.vue";
import FormDatetimePicker from "@/pc/components/forms/FormDatetimePicker.vue";
import QuestionInputItem, { QuestionInputItemModel, QuestionInputSelectItemModel, QuestionInputTextItemModel } from "@/pc/containers/questionnaires/QuestionInputItem.vue";
import SendMessageTargetCheck, { SendMessageTarget } from "@/pc/containers/questionnaires/SendMessageTargetCheck.vue";
import SendMessageTargetsInput, { GroupModel } from "@/pc/containers/questionnaires/SendMessageTargetsInput.vue";
import SendMessageSelectModal from "@/pc/components/modals/SendMessageSelectModal.vue";
import SendMessageOtherUserGroupSelectModal from "@/pc/components/modals/SendMessageOtherUserGroupSelectModal.vue";
import SendMessageGroupSelectModal from "@/pc/containers/questionnaires/SendMessageGroupSelectModal.vue";
import PreviewQuestionnairesMoldal from "@/pc/containers/questionnaires/PreviewQuestionnaireModal.vue";
import ShareStandardUserCheckboxs, { ShareStandardUserCheckbox } from "@/pc/containers/questionnaires/ShareStandardUserCheckBoxs.vue";
import QuestionnaireFilePreviewModal from "@/pc/containers/questionnaires/QuestionnaireFilePreviewModal.vue";
import { GroupType } from "@/pc/components/modals/SendMessageGroupSelectModal.vue";

/**
 * ### アンケート登録画面コンポーネント
 */
@Component({
  components: {
    FileUploadErrorModal,
    PageLoading,
    ProgressLoading,
    ValidationAlert,
    OkCancelModal,
    OkModal,
    HelpIcon,
    FormInput,
    FormTextarea,
    FormMultiFile,
    DraggableFiles,
    FormCheck,
    FormDatetimePicker,
    QuestionInputItem,
    SendMessageTargetCheck,
    SendMessageTargetsInput,
    SendMessageSelectModal,
    SendMessageOtherUserGroupSelectModal,
    SendMessageGroupSelectModal,
    QuestionnaireFilePreviewModal,
    PreviewQuestionnairesMoldal,
    ShareStandardUserCheckboxs
  },
  $_veeValidate: { validator: "new" }
})
export default class QuestionnaireRegister extends Vue {
  /** アンケートサービス */
  @Inject("QuestionnairesService") questionnairesService!: QuestionnairesService;
  /** アカウントサービス */
  @Inject("StandardAccountsService") standardAccountsService!: StandardAccountsService;
  /** S3格納先URLサービス */
  @Inject("S3LocationsService") s3LocationsService!: S3LocationsService;
  /** S3ファイルアップロードサービス */
  @Inject("S3UploadsService") s3UploadsService!: S3UploadsService;
  /** S3ファイル存在確認サービス */
  @Inject("ExistS3FilesService") existS3FilesService!: ExistS3FilesService;

  @Ref()
  sendMessageTargetsInput!: SendMessageTargetsInput;
  @Ref()
  sendMessageSelectModal!: SendMessageSelectModal;
  @Ref()
  otherUserGroupSelectModal!: SendMessageOtherUserGroupSelectModal;
  @Ref()
  sendMessageGroupSelectModal!: SendMessageGroupSelectModal;
  @Ref()
  filePreviewModal!: QuestionnaireFilePreviewModal;

  /** 添付許可Content-Typeリスト */
  readonly allowContentType = ["image/jpeg", "image/png", "application/pdf", "video/mp4", "video/quicktime"];
  readonly allowMessageType = ["image", "image", "pdf", "video", "video"];

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** 登録確認モーダル表示可否 */
  showRegisterModal: boolean = false;
  /** 登録確認モーダルタイトル */
  registerMessage: string = "";
  /** 登録完了モーダル表示可否 */
  showRegisterSuccessModal: boolean = false;
  /** 送信確認モーダル表示可否 */
  showSendModal: boolean = false;
  /** 送信完了モーダル表示可否 */
  showSendSuccessModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 現在のファイルアップロード数 */
  currentUploadCount: number = 0;
  /** ファイルアップロード総数 */
  uploadCount: number = 0;
  /** プログレスモーダルメッセージ */
  progressMessage: string = "";
  /** プログレスモーダル表示可否 */
  progressLoading: boolean = false;

  /** プレビューモーダル表示可否 */
  showPreviewModal: boolean = false;

  /** プラン種別 */
  planType: PlanType = PlanType.UNKNOWN;

  /** コピー登録の場合のコピー元アンケート */
  sourceQuestionnaire: QuestionnairesGetModel | null = null;

  /** アンケートタイトル */
  title: string = "";
  /** アンケート説明文 */
  text: string = "";
  /** 実際に登録するファイル */
  files: Array<ExtDraggableFile> = [];
  /** 匿名にするか否か */
  hidden: boolean = false;
  /** 追加する質問項目の種類 */
  questionType: TemplateType = TemplateType.SELECT;
  /** 追加する質問項目の種類選択肢 */
  questionTypeOptions: Array<{ value: number | string; label: string }> = [
    { value: TemplateType.SELECT, label: "選択肢" },
    { value: TemplateType.TEXT, label: "テキスト" }
  ];
  /** アンケート内容 */
  questions: Array<QuestionInputItemModel> = [];

  /** 回答期限を設定するか */
  enableAnswerLimit: boolean = false;
  /** 期日 */
  replyLimit: number | null = null;
  /** 期日(日付) */
  replyLimitDate: string = "";
  /** 期日(時間) */
  replyLimitTime: string = "";

  /** 宛先種別 */
  targetType: SendMessageTarget | null = null;
  /** 宛先グループの種別（宛先グループや利用者グループなど） */
  groupType: GroupType = GroupType.UNKNOWN;
  /** 宛先種別 */
  targets: string[] = [];
  /** メッセージタイトル */
  messageTitle: string = "";
  /** メッセージ本文 */
  messageText: string = "";

  /** 共有一般ユーザー */
  shareStandardUsers: Array<ShareStandardUserCheckbox> = [];

  /** 質問項目のバリデーションエラーメッセージ */
  questionErrorMessage: string = "";
  /** 宛先のバリデーションエラーメッセージ */
  targetErrorMessage: string = "";
  /** ファイルアップロードエラーモーダル表示可否 */
  showUploadErrorModal: boolean = false;

  /** ファイル登録数 */
  readonly registerFileUploadLimit: number = 3;

  /**
   * ### 質問項目追加ボタンの非活性を返す
   */
  get _disableQuestionnaireBtn(): boolean {
    if (this.questions.length < 50) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * ### プレビューボタンの非活性を返す
   */
  get _disablePreviewBtn(): boolean {
    if (0 < this.questions.length) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * ### 登録可能なファイル数を返す
   */
  get _registerImageFilesLimit(): number {
    const limit: number = this.registerFileUploadLimit - this.files.length;
    return limit;
  }

  /**
   * ### プレビュー表示可否を返す
   */
  get _enablePreviewStatus(): boolean {
    return 0 < this.files.length ? true : false;
  }

  /**
   * ### vue lifecycle created
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面情報作成
   *
   * - 期日の初期値を作成する
   */
  public async createView(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.planType = userStore.facility.planType;

    const replyLimitDate: Date = new Date();
    replyLimitDate.setDate(replyLimitDate.getDate() + 7);
    this.replyLimitDate = this.$dateUtil.convertDateToString(new Date(), "yyyy-mm-dd");
    this.replyLimitTime = "10:00:00";

    const accounts: Array<StandardAccountsGetModel> = await this.getAccounts();
    const shareStandardUsers: Array<ShareStandardUserCheckbox> = this.createShareStandardUsers(accounts);
    this.shareStandardUsers = shareStandardUsers;

    // コピー登録の場合、コピー元のアンケートを取得して初期入力として使用する
    const id: string | (string | null)[] = this.$route.query.id;
    if (id) {
      const sourceId: number = Number(id);
      const questionnaire: QuestionnairesGetModel = await this.getQuestionnaire(sourceId);
      this.sourceQuestionnaire = questionnaire;
      this.setQuestionnaire(questionnaire, accounts);
    }
    // TODO 宛先(宛先グループ)が読込み終わらないと読み込み中を解除できない
    // loadedGroupTargets()が呼び出されたら完了だが、ここで制御できるようにしたい
    // コピーではなく新規登録の場合はloadedGroupTargets()が呼ばれないのでここで読込み中を解除する必要がある
    else {
      this.isBusy = false;
    }

    // storeに一時保存した入力内容を復元する
    this.restoreScreenInputTemporaryStore();

    return;
  }

  /**
   * ### 一般ユーザーを取得する
   */
  public async getAccounts(): Promise<Array<StandardAccountsGetModel>> {
    const response: Array<StandardAccountsGetModel> = await this.standardAccountsService.get(userStore);
    return response;
  }

  /**
   * ### 共有ユーザーの選択肢を作成する
   */
  public createShareStandardUsers(accounts: Array<StandardAccountsGetModel>): Array<ShareStandardUserCheckbox> {
    const checkboxs: Array<ShareStandardUserCheckbox> = [];
    for (const account of accounts) {
      checkboxs.push({
        id: account.userId,
        answer: userStore.loginUser.userId == account.userId ? true : false,
        name: account.name,
        disabled: userStore.loginUser.userId == account.userId ? true : false
      });
    }
    return checkboxs;
  }

  /**
   * ### アンケートを取得する
   */
  public async getQuestionnaire(id: number): Promise<QuestionnairesGetModel> {
    const response: QuestionnairesGetModel = await this.questionnairesService.get(userStore, id);
    return response;
  }

  /**
   * ### 画面表示用のアンケート情報を格納する
   */
  public setQuestionnaire(questionnaire: QuestionnairesGetModel, accounts: Array<StandardAccountsGetModel>): void {
    this.title = questionnaire.title;
    this.text = questionnaire.text;
    this.hidden = questionnaire.hidden;
    this.questions = this.createQuestions(questionnaire.questions);

    if (questionnaire.replyLimit) {
      this.enableAnswerLimit = true;
      this.replyLimit = questionnaire.replyLimit;
      this.replyLimitDate = this.$dateUtil.convertNumberToString(questionnaire.replyLimit, "yyyy-mm-dd");
      this.replyLimitTime = this.$dateUtil.convertNumberToString(questionnaire.replyLimit, "hh:MM:ss");
    } else {
      this.enableAnswerLimit = false;
      const replyLimitDate: Date = new Date();
      replyLimitDate.setDate(replyLimitDate.getDate() + 7);
      this.replyLimitDate = this.$dateUtil.convertDateToString(new Date(), "yyyy-mm-dd");
      this.replyLimitTime = "10:00:00";
    }

    this.targetType = this.createSendTargetType(questionnaire.targetType);
    this.groupType = this.createGroupType(questionnaire);
    this.messageTitle = questionnaire.messageTitle;
    this.messageText = questionnaire.messageText;

    this.shareStandardUsers = this.copyShareStandardUsers(questionnaire, accounts);

    return;
  }

  /**
   * ### 子コンポーネントでファイルが選択された場合のイベント処理
   *
   * - ファイルが上限数以上なら無視する
   * - バリデーションを行う
   * - バリデーションエラーでなければ、ファイルを追加する
   */
  public async inputFiles(files: Array<File>): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const questionnaireFileCommon: QuestionnaireFileCommon = new QuestionnaireFileCommon(this.$validator, "tempfiles-multiple-register-errors");
    const addFiles: Array<ExtDraggableFile> = await questionnaireFileCommon.createAddFile(files, this.registerFileUploadLimit, this.files.length);

    if (0 < addFiles.length) {
      this.files = this.files.concat(addFiles);
      for (let i = 0; i < this.files.length; i++) {
        this.files[i].key = i.toString();
      }
    }

    this.isBusy = false;
    return;
  }

  /**
   * ### 添付ファイルプレビューボタン押下イベント処理
   *
   * - ダイアログで添付ファイルをプレビュー表示する
   */
  public onTempFilePreview(): void {
    const files = [];
    for (const file of this.files) {
      files.push(file.fileObject as File);
    }
    if (this.filePreviewModal && this.filePreviewModal instanceof QuestionnaireFilePreviewModal) {
      this.filePreviewModal.show("", false, files);
    }
    return;
  }

  /**
   * ### 指定されたファイルを削除する
   */
  public onFileDelete(index: number): void {
    this.files.splice(index, 1);
    return;
  }

  /**
   * ### 画面表示用の質問項目を作成する
   */
  public createQuestions(questionItems: Array<QuestionTemplateItem>): Array<QuestionInputItemModel> {
    const questions: Array<QuestionInputItemModel> = [];
    for (const questionItem of questionItems) {
      questions.push({
        ...questionItem,
        isFocused: false
      });
    }
    return questions;
  }

  /**
   * ### 画面用の宛先種別を作成する
   */
  public createSendTargetType(targetType: TargetType): SendMessageTarget | null {
    switch (targetType) {
      case TargetType.ALL_FAMILIES: {
        return SendMessageTarget.ALL_FAMILIES;
      }
      case TargetType.FAMILIES: {
        return SendMessageTarget.FAMILIES;
      }
      case TargetType.OTHER_USERS: {
        return SendMessageTarget.OTHER_USERS;
      }
      case TargetType.SEND_MESSAGE_GROUPS:
      case TargetType.RESIDENT_GROUPS:
      case TargetType.OTHER_USER_GROUPS: {
        return SendMessageTarget.GROUPS;
      }
    }
  }

  /**
   * ### 画面用のグループ種別を作成する
   */
  public createGroupType(questionnaire: QuestionnairesGetModel): GroupType {
    switch (questionnaire.targetType) {
      case TargetType.ALL_FAMILIES:
      case TargetType.FAMILIES:
      case TargetType.OTHER_USERS: {
        return GroupType.UNKNOWN;
      }
      case TargetType.SEND_MESSAGE_GROUPS: {
        if (questionnaire.sendMessageGroupInfos && 0 < questionnaire.sendMessageGroupInfos.length && questionnaire.sendMessageGroupInfos[0].type == 0) {
          return GroupType.FAMILY;
        } else {
          return GroupType.OTHER_USER;
        }
      }
      case TargetType.RESIDENT_GROUPS: {
        return GroupType.RESIDENT_GROUP;
      }
      case TargetType.OTHER_USER_GROUPS: {
        return GroupType.OTHER_USER_GROUP;
      }
    }
  }

  /**
   * ### 共有ユーザーの選択肢を作成する
   */
  public copyShareStandardUsers(questionnaire: QuestionnairesGetModel, accounts: Array<StandardAccountsGetModel>): Array<ShareStandardUserCheckbox> {
    const accountMap: Map<string, StandardAccountsGetModel> = new Map<string, StandardAccountsGetModel>();
    for (const account of accounts) {
      accountMap.set(account.userId, account);
    }
    const shareStandardUserMap: Map<string, StandardAccountsGetModel> = new Map<string, StandardAccountsGetModel>();
    for (const user of questionnaire.shareStandardUsers) {
      if (accountMap.has(user)) {
        shareStandardUserMap.set(user, accountMap.get(user)!);
      }
    }
    for (const user of this.shareStandardUsers) {
      if (shareStandardUserMap.has(user.id)) {
        user.answer = true;
      } else {
        user.answer = false;
      }
    }
    return this.shareStandardUsers;
  }

  /**
   * ### 家族個別の読み込み完了イベント
   *
   * - 子コンポーネントから呼び出される
   * - 一時保存されたアンケート情報の送信種別が家族個別であれば子コンポーネントに宛先を渡して復元させる
   */
  public loadedFamiliesTargets(): void {
    if (this.sourceQuestionnaire && this.sourceQuestionnaire.targetType == TargetType.FAMILIES) {
      this.sendMessageTargetsInput.restoreFamilyTargets(this.sourceQuestionnaire.targets);
    }
    return;
  }

  /**
   * ### 施設関係者個別の読み込み完了イベント
   *
   * - 子コンポーネントから呼び出される
   * - 一時保存されたアンケート情報の送信種別が施設関係者個別であれば子コンポーネントに宛先を渡して復元させる
   */
  public loadedOtherUserTargets(): void {
    if (this.sourceQuestionnaire && this.sourceQuestionnaire.targetType == TargetType.OTHER_USERS) {
      this.sendMessageTargetsInput.restoreOtherUserTargets(this.sourceQuestionnaire.targets);
    }
    return;
  }

  /**
   * ### 宛先グループの読み込み完了イベント
   *
   * - 子コンポーネントから呼び出される
   * - 一時保存されたアンケート情報の送信種別が宛先グループであれば子コンポーネントに宛先を渡して復元させる
   */
  public loadedGroupTargets(): void {
    if (
      this.sourceQuestionnaire &&
      (this.sourceQuestionnaire.targetType == TargetType.SEND_MESSAGE_GROUPS ||
        this.sourceQuestionnaire.targetType == TargetType.RESIDENT_GROUPS ||
        this.sourceQuestionnaire.targetType == TargetType.OTHER_USER_GROUPS)
    ) {
      const questionnaire = this.sourceQuestionnaire;
      this.sendMessageTargetsInput.restoreGroupTargets(questionnaire.sendMessageGroupInfos, questionnaire.residentGroupInfos, questionnaire.otherUserGroupInfos);
    }
    // TODO ここで読込み完了ではなく、createView()でやりたい
    this.isBusy = false;
    return;
  }

  /**
   * ### 質問項目を追加する
   */
  public addQuestion(type: TemplateType): void {
    switch (type) {
      case TemplateType.TEXT: {
        const textItem: QuestionInputTextItemModel = {
          type: type,
          title: "",
          answer: "",
          isLong: false,
          required: false,
          isFocused: false
        };
        this.questions.push(textItem);
        break;
      }
      case TemplateType.SELECT: {
        const selectItem: QuestionInputSelectItemModel = {
          type: type,
          title: "",
          answer: [],
          options: [
            { text: "", value: "1" },
            { text: "", value: "2" }
          ],
          multiple: false,
          required: false,
          isFocused: false
        };
        this.questions.push(selectItem);
        break;
      }
    }
    this.$bvToast.hide("add-questionnaire-toast");
    return;
  }

  /** ### プレビューを表示する */
  public previewQuestion(): void {
    this.showPreviewModal = true;
    return;
  }

  /**
   * ### 質問項目を削除する
   */
  public onQuestionDelete(index: number): void {
    this.questions.splice(index, 1);
    return;
  }

  /**
   * ### 質問項目を一つ後ろに移動する
   */
  public onQuestionMoveDown(index: number): void {
    if (index < 0 || this.questions.length - 1 <= index) {
      // インデックスが範囲外の場合は何もしない
      return;
    }
    // 要素を一つ後ろに移動する
    const target = this.questions[index];
    this.questions.splice(index, 1);
    this.questions.splice(index + 1, 0, target);
    return;
  }

  /**
   * ### 質問項目を一つ前に移動する
   */
  public onQuestionMoveUp(index: number): void {
    // インデックスが範囲外の場合は何もしない
    if (index <= 0 || this.questions.length <= index) {
      return;
    }
    // 要素を一つ前に移動する
    const target = this.questions[index];
    this.questions.splice(index, 1);
    this.questions.splice(index - 1, 0, target);
    return;
  }

  /**
   * ### 質問項目(select)の要素を削除する
   */
  public onQuestionOptionDelete(indexs: { index: number; optionIndex: number }): void {
    const selectItem: QuestionInputSelectItemModel = this.questions[indexs.index] as QuestionInputSelectItemModel;
    selectItem.options.splice(indexs.optionIndex, 1);
    return;
  }

  /**
   * ### 質問項目(select)の要素を追加する
   */
  public onQuestionAddSelectOption(index: number): void {
    const selectItem: QuestionInputSelectItemModel = this.questions[index] as QuestionInputSelectItemModel;
    selectItem.options.push({
      text: ``,
      value: `${selectItem.options.length + 1}`
    });

    return;
  }

  /**
   * ### 質問項目のフォーカスリセット
   *
   * - 質問項目以外がクリックされた際に呼ばれる
   * - 質問項目以外にフォーカスがあっているように見せる
   */
  public resetFocus(): void {
    for (let i = 0; i < this.questions.length; i++) {
      this.questions[i].isFocused = false;
    }
    return;
  }

  /**
   * ### 質問項目のフォーカスセット
   *
   * - 選択されていない項目のフォーカスはfalseにすることで疑似的にフォーカスを当てているように見せる
   */
  public focusInQuestion(index: number): void {
    for (let i = 0; i < this.questions.length; i++) {
      if (i == index) {
        this.questions[i].isFocused = true;
      } else {
        this.questions[i].isFocused = false;
      }
    }
    return;
  }

  public onFamiliesSelect(familiesTargets: Array<SendMessageTargetGroup>): void {
    const copy: Array<SendMessageTargetGroup> = JSON.parse(JSON.stringify(familiesTargets));
    this.sendMessageSelectModal.show(copy);
    return;
  }

  public addFamiliesTarget(targets: Array<SendMessageTargetGroup>): void {
    this.sendMessageTargetsInput._familiesTargets = targets;
    return;
  }

  public onOtherUserGroupsSelect(otherUserTargets: Array<OtherUserGroupTypeGroup>): void {
    const copy: Array<OtherUserGroupTypeGroup> = JSON.parse(JSON.stringify(otherUserTargets));
    this.otherUserGroupSelectModal.show(copy);
    return;
  }

  public addOtherUserGroupTarget(targets: Array<OtherUserGroupTypeGroup>): void {
    this.sendMessageTargetsInput._otherUserTargets = targets;
    return;
  }

  public onSendMessageGroupSelect(groupTargets: GroupModel): void {
    const copy: GroupModel = JSON.parse(JSON.stringify(groupTargets));
    this.sendMessageGroupSelectModal.show(copy);
    return;
  }

  public addSendGroupTarget(targets: GroupModel): void {
    this.sendMessageTargetsInput._groupTargets = targets;
    return;
  }

  /**
   * ### 一時保存確認モーダルを表示する
   */
  public async showRegisterConfirmModal(): Promise<void> {
    this.showRegisterModal = true;
    return;
  }

  /**
   * ### アンケートを一時保存で登録する
   */
  public async registerQuestionnaire(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "登録中...";

    // ファイルが添付されていればファイルのアップロード
    let fileUrls: Array<FileUrl> = [];
    // ファイルアップロードするタイミングでファイルが削除（移動含む）、リネームされた場合は失敗するのでここでtry-catchする
    // アップロードに失敗した場合は添付されたファイルを全てリセットしてモーダルで再添付を促す
    try {
      if (0 < this.files.length) {
        const targetFiles = [];
        for (const file of this.files) {
          targetFiles.push(file.fileObject as File);
        }
        const urls: Array<S3LocationResponse> = await this.createUploadUrls(targetFiles, S3LocationType.QUESTIONNAIRE);
        fileUrls = await this.uploadFiles(urls);
      }
    } catch (error) {
      this.isBusy = false;

      this.showUploadErrorModal = true;
      this.files = [];

      return;
    }

    this.setScreenInputTemporaryStore();
    const targets: { targets: string[]; lineTargets: string[]; mailTargets: string[] } = await this.sendMessageTargetsInput.createTargets();
    const requestBody: QuestionnairesPostModel = this.createQuestionnairesPostModel(targets, fileUrls);
    await this.questionnairesService.post(userStore, requestBody);
    this.resetScreenInputTemporaryStore();

    this.isBusy = false;
    this.showRegisterSuccessModal = true;

    return;
  }

  /**
   * ### ファイルアップロード先のURLを発行する
   */
  public async createUploadUrls(files: Array<File>, s3LocationType: S3LocationType): Promise<Array<S3LocationResponse>> {
    let extensions: Array<string> = [];
    for (const file of files) {
      const _file: Array<string> = file.name.split("/");
      const _extensions: Array<string> = _file[_file.length - 1].split(".");
      extensions.push("." + _extensions[_extensions.length - 1]);
    }
    const params: S3LocationMessage = {
      userId: userStore.loginUser.userId
    };
    const requestBody: S3LocationRequest = {
      type: s3LocationType,
      count: files.length,
      extensions: extensions,
      params: params,
      acl: "public-read"
    };
    const url: Array<S3LocationResponse> = await this.s3LocationsService.post(userStore, requestBody);

    return url;
  }

  /**
   * ### プログレスローディングを表示してファイルアップロードする
   */
  public async uploadFiles(urls: Array<S3LocationResponse>): Promise<Array<FileUrl>> {
    const fileUrls: Array<FileUrl> = [];

    try {
      // プログレス付きモーダルを表示する
      // 進捗はファイルのアプロード状況を反映させるようにする
      this.currentUploadCount = 0;
      this.uploadCount = this.files.length;
      this.progressMessage = "ファイルアップロード中。\n完了するまでそのままお待ちください。\nメッセージ送信中に別画面に遷移しますと処理がキャンセルされます。";
      this.progressLoading = true;
      // アップロード
      for (let i = 0; i < urls.length; i++) {
        this.currentUploadCount = i;
        await this.s3UploadsService.uploadFile(urls[i], this.files[i].fileObject as File);

        // DBにはファイルではなく、添付ファイルのS3URLを保持するためURL配列を作成する
        const preUrl: string = urls[i].url.endsWith("/") ? urls[i].url : `${urls[i].url}/`;
        const s3Url: string = `${preUrl}${urls[i].fields["key"]}`;

        const index: number = this.allowContentType.indexOf(this.files[i].fileObject!.type);
        const type: string = this.allowMessageType[index];

        fileUrls.push({
          name: this.files[i].name,
          type: type,
          url: s3Url
        });
      }
      // アップロードしたファイルはサムネイル画像が作成されたり、movからmp4への変換が行われる
      // ファイルの存在確認をして変換されたか確認する
      await this.existFile(fileUrls);
    } finally {
      this.progressLoading = false;
    }

    return fileUrls;
  }

  /**
   * ### ファイルの存在確認を行う
   */
  public async existFile(fileUrls: Array<FileUrl>): Promise<void> {
    // ファイルがアップロードされているかをチェックする
    const s3Urls: string[] = [];
    for (const fileUrl of fileUrls) {
      s3Urls.push(fileUrl.url);
    }
    const fileRequestBody: ExistS3FilesPostModel = { urls: s3Urls };
    await this.existS3FilesService.post(userStore, fileRequestBody);

    // サムネイルのファイルが存在しているかをチェックする
    let thumbnailUrls: Array<string> = [];
    for (const s3Url of s3Urls) {
      // サムネイルのファイル名は<元ファイル名>_thumbnailになる
      const splitedUrl: string[] = s3Url.split("/");
      const splitedFileName: string[] = splitedUrl[splitedUrl.length - 1].split(".");

      // mov、mp4以外の場合はサムネイルをメッセージ送信時に作成するのでスキップ
      if (splitedFileName[1] != "mov" && splitedFileName[1] != "mp4") {
        continue;
      }

      const thumbnailFileName: string = splitedFileName[0] + "_thumbnail.jpeg";
      let thunmbnailUrl: string = "";
      for (let i = 0; i < splitedUrl.length - 1; i++) {
        thunmbnailUrl += splitedUrl[i] + "/";
      }
      thunmbnailUrl += thumbnailFileName;
      thumbnailUrls.push(thunmbnailUrl);
    }

    if (0 < thumbnailUrls.length) {
      const thumbnailRequestBody: ExistS3FilesPostModel = { urls: thumbnailUrls };
      await this.existS3FilesService.post(userStore, thumbnailRequestBody);
    }

    return;
  }

  public createQuestionnairesPostModel(targets: { targets: string[]; lineTargets: string[]; mailTargets: string[] }, fileUrls: Array<FileUrl>): QuestionnairesPostModel {
    return {
      title: this.title ? this.title : null,
      text: this.text ? this.text : null,
      fileUrls: fileUrls,
      hidden: this.hidden,
      messageTitle: this.messageTitle ? this.messageTitle : null,
      messageText: this.messageText ? this.messageText : null,
      targets: targets.targets,
      lineTargets: targets.lineTargets,
      mailTargets: targets.mailTargets,
      sendMessageGroupInfos: this.sendMessageTargetsInput.createSendMessageGroupInfos(),
      residentGroupInfos: this.sendMessageTargetsInput.createResidentGroupInfos(),
      otherUserGroupInfos: this.sendMessageTargetsInput.createOtherUserGroupInfos(),
      targetType: this.createTargetType(this.targetType as SendMessageTarget, this.groupType),
      questions: this.createQuestionTemplateItems(this.questions),
      replyLimit: this.enableAnswerLimit == true ? this.replyLimit : null,
      needSendMessage: false, // メッセージ送信はしない
      shareStandardUsers: this.createRequestShareStandardUsers(this.shareStandardUsers)
    };
  }

  public createTargetType(targetType: SendMessageTarget, groupType: GroupType): TargetType | null {
    switch (targetType) {
      case SendMessageTarget.ALL_FAMILIES: {
        return TargetType.ALL_FAMILIES;
      }
      case SendMessageTarget.FAMILIES: {
        return TargetType.FAMILIES;
      }
      case SendMessageTarget.OTHER_USERS: {
        return TargetType.OTHER_USERS;
      }
      case SendMessageTarget.GROUPS: {
        switch (groupType) {
          case GroupType.FAMILY:
          case GroupType.OTHER_USER: {
            return TargetType.SEND_MESSAGE_GROUPS;
          }
          case GroupType.RESIDENT_GROUP: {
            return TargetType.RESIDENT_GROUPS;
          }
          case GroupType.OTHER_USER_GROUP: {
            return TargetType.OTHER_USER_GROUPS;
          }
        }
      }
    }
    return null;
  }

  public createQuestionTemplateItems(questions: Array<QuestionInputItemModel>): Array<QuestionTemplateItem> {
    let questionTemplateItems: Array<QuestionTemplateItem> = [];
    for (const question of questions) {
      // selectはオプションを足したり消したりできるので、value値はここで連番に整える必要がある
      if (question.type == TemplateType.SELECT) {
        const selectQuestion: QuestionInputSelectItemModel = question as QuestionInputSelectItemModel;
        for (let i = 0; i < selectQuestion.options.length; i++) {
          selectQuestion.options[i].value = `${i}`;
        }
      }
      // isFocusedでプロパティ削除
      const questionTemplateItem: any = question;
      delete questionTemplateItem.isFocused;

      questionTemplateItems.push(questionTemplateItem);
    }
    return questionTemplateItems;
  }

  public createRequestShareStandardUsers(shareStandardUserCheckboxs: Array<ShareStandardUserCheckbox>): string[] {
    const shareStandardUsers: string[] = [];
    for (const checkbox of shareStandardUserCheckboxs) {
      if (checkbox.answer == true) {
        shareStandardUsers.push(checkbox.id);
      }
    }
    return shareStandardUsers;
  }

  /**
   * ### 送信確認モーダルを表示する
   */
  public async showSendConfirmModal(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    const questionsValidationResult: boolean = this.validateQuestions();
    const targetsValidationResult: boolean = await this.validateTargets();
    const fileValidationResult: boolean = this.validateFiles();

    if (validationResult && questionsValidationResult && targetsValidationResult && fileValidationResult) {
      this.showValidationAlert = false;
      this.showSendModal = true;
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  public validateQuestions(): boolean {
    this.questionErrorMessage = "";
    if (this.questions.length < 1) {
      this.questionErrorMessage = "質問項目は必須入力です";
      return false;
    } else {
      return true;
    }
  }

  public async validateTargets(): Promise<boolean> {
    this.targetErrorMessage = "";
    const targets: { targets: string[]; lineTargets: string[]; mailTargets: string[] } = await this.sendMessageTargetsInput.createTargets();
    if (targets.targets.length < 1) {
      this.targetErrorMessage = "宛先にユーザーがいないため、送信できません";
      return false;
    } else {
      return true;
    }
  }

  /**
   * ### ファイルバリデーション
   *
   * - 何らかの原因でファイルが存在しないパターンがあったので、チェック処理を行う
   */
  public validateFiles(): boolean {
    for (const file of this.files) {
      if (!file || !file.name || (file.fileObject && file.fileObject.size == 0)) {
        this.$validator.errors.add({
          field: "tempfiles-multiple-register-errors",
          msg: `ファイルが破損等をしている可能性があり、ファイルを認識することができません。お手数ですが、再度選択し直してください。`
        });
        return false;
      }
    }
    return true;
  }

  /**
   * ### アンケートを送信する
   */
  public async sendQuestionnaire(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "送信中...";

    // ファイルが添付されていればファイルのアップロード
    let fileUrls: Array<FileUrl> = [];
    // ファイルアップロードするタイミングでファイルが削除（移動含む）、リネームされた場合は失敗するのでここでtry-catchする
    // アップロードに失敗した場合は添付されたファイルを全てリセットしてモーダルで再添付を促す
    try {
      if (0 < this.files.length) {
        const targetFiles = [];
        for (const file of this.files) {
          targetFiles.push(file.fileObject as File);
        }
        const urls: Array<S3LocationResponse> = await this.createUploadUrls(targetFiles, S3LocationType.QUESTIONNAIRE);
        fileUrls = await this.uploadFiles(urls);
      }
    } catch (error) {
      this.isBusy = false;

      this.showUploadErrorModal = true;
      this.files = [];

      return;
    }

    this.setScreenInputTemporaryStore();
    const targets: { targets: string[]; lineTargets: string[]; mailTargets: string[] } = await this.sendMessageTargetsInput.createTargets();
    const requestBody: QuestionnairesPostModel = this.createQuestionnairesPostModel(targets, fileUrls);
    requestBody.needSendMessage = true; // メッセージ送信する
    await this.questionnairesService.post(userStore, requestBody);
    this.resetScreenInputTemporaryStore();

    // TODO API側でアンケートを登録⇒LINE送信⇒アンケートを更新するので、処理に時間がかかるため、タイマーセットしてDB更新を待つ
    // APIから処理完了を受信する方法がありそうだが、現状は不明なのでタイマーで対応している
    await this.$timerUtil.setTimeout(5000);

    this.isBusy = false;
    this.showSendSuccessModal = true;

    return;
  }

  /**
   * ### 画面入力情報をstoreから復元し、store情報を初期化する
   */
  public restoreScreenInputTemporaryStore(): void {
    if (screenInputTemporaryStore.url == PcUrl.QuestionnaireRegister) {
      this.title = screenInputTemporaryStore.inputParams.title;
      this.text = screenInputTemporaryStore.inputParams.text;
      this.hidden = screenInputTemporaryStore.inputParams.hidden;
      const questions: Array<QuestionInputItemModel> = [];
      for (const questionItem of screenInputTemporaryStore.inputParams.questions) {
        questions.push({
          ...questionItem,
          isFocused: false
        });
      }
      this.questions = questions;
      this.enableAnswerLimit = screenInputTemporaryStore.inputParams.enableAnswerLimit;
      this.replyLimit = screenInputTemporaryStore.inputParams.replyLimit;
      this.targetType = screenInputTemporaryStore.inputParams.targetType;
      this.messageTitle = screenInputTemporaryStore.inputParams.messageTitle;
      this.messageText = screenInputTemporaryStore.inputParams.messageText;
      this.shareStandardUsers = screenInputTemporaryStore.inputParams.shareStandardUsers;

      this.resetScreenInputTemporaryStore();
    }
    return;
  }

  /**
   * ### 画面入力情報のstoreをリセットする
   */
  public resetScreenInputTemporaryStore(): void {
    screenInputTemporaryStore.initializeScreenInputTemporary();
    return;
  }

  /**
   * ### 画面入力情報をstoreに格納する
   *
   * - 一時間無操作タイムアウト対策としてAPIリクエスト前にstoreに保存する
   */
  public setScreenInputTemporaryStore(): void {
    screenInputTemporaryStore.setScreenInputTemporary({
      url: PcUrl.QuestionnaireRegister,
      inputParams: {
        title: this.title,
        text: this.text,
        hidden: this.hidden,
        questions: this.questions,
        enableAnswerLimit: this.enableAnswerLimit,
        replyLimit: this.replyLimit,
        targetType: this.targetType,
        messageTitle: this.messageTitle,
        messageText: this.messageText,
        shareStandardUsers: this.shareStandardUsers
      }
    });
    return;
  }

  /**
   * ### アンケート一覧画面へ遷移する
   */
  public gotoQuestionnaireList(): void {
    this.$router.push(PcUrl.QuestionnaireList);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

// 親要素からネストしてスタイルを指定する
#questionnaires-register {
  max-width: 660px;
  margin-left: auto;
  margin-right: auto;

  .box-header {
    width: 100%;

    .title {
      font-size: 22px;
      font-weight: bold;
    }
  }

  .sub-title {
    font-size: 18px;
    font-weight: bold;
  }

  .toast-title {
    font-size: 16px;
    color: $font-base-color;
  }

  .validation-label {
    color: $validation-label-font-color;
    font-size: 12px;
    border: 1px solid $validation-label-font-color;
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
    background-color: #fff;
  }

  .add-question-buttons {
    padding: 0 20px 0 20px;

    .input-select {
      display: block;
      min-width: 320px;
      max-width: 320px;
      height: 42px;
      padding: 6px 12px;
      background-color: $bg-default;
      border: 1px solid $form-border-color;
      border-radius: 0.25rem;
      &:focus {
        // chromeが自動的に付与するスタイルを無効化する
        outline: none;
        box-shadow: 0 0 0 0.2rem $form-boxshadow-select-color;
        border: 1px solid $form-border-select-color !important;
        border-radius: 0.25rem;
      }
    }
    .add-question-btn {
      width: 140px;
    }
  }

  .questionnaires,
  .share-standard-users {
    padding: 0 20px 0 20px;
  }

  .register-btn,
  .send-btn,
  .cancel-btn {
    width: 120px;
  }

  // 子コンポーネントに強制的にスタイルを指定しないtoastの幅が小さい
  ::v-deep {
    .b-toast,
    .toast {
      width: 400px !important;
      max-width: 400px !important;
    }
    .questionnaire-item-btn {
      height: 80px;
      width: 180px;
      border: 1px solid $border-darkgray;

      &:hover {
        background-color: $btn-hover !important;
        transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
      }

      .questionnaire-item {
        font-size: 20px;
        color: $font-base-color;
        opacity: 0.75;
        text-shadow: 0 1px 0 #fff;
      }
    }
  }
}
</style>
